const initialState = {
  totalFullScreenClaims: 0
};
const sidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SIDEBAR_CLAIM_FULLSCREEN':
      return Object.assign({}, state, {
        totalFullScreenClaims: state.totalFullScreenClaims + 1
      });
    case 'SIDEBAR_RELEASE_FULLSCREEN':
      return Object.assign({}, state, {
        totalFullScreenClaims: state.totalFullScreenClaims - 1
      });
    default:
      return state;
  }
};
export default sidebarReducer;